import { useCubeQuery } from '@cubejs-client/react';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { DimPurchaseOrderField } from '~/common/types/cubes/DimPuchaseOrder';
import { PurchaseOrderSourceSystemField } from '~/common/types/cubes/PurchaseOrderSourceSystem';
import { BaseDetailHeader, BaseDetailHeaderProps } from '~/components/BaseDetailHeader/BaseDetailHeader';

export interface OrderDetailHeaderProps {
  id: string;
  tabs?: BaseDetailHeaderProps['tabs'];
  actionsRight?: ReactNode;
}

export const OrderDetailHeader = ({ id, tabs, actionsRight }: OrderDetailHeaderProps) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'OrderDetail' });

  const dimPurchaseOrderQuery = useCubeQuery({
    dimensions: [DimPurchaseOrderField.PRIMARY_SOURCE_REFERENCE],
    filters: [{ member: DimPurchaseOrderField.ID, operator: 'equals', values: [id] }],
  });
  const sourceSystemQuery = useCubeQuery({
    dimensions: [
      PurchaseOrderSourceSystemField.SOURCE_REFERENCE,
      PurchaseOrderSourceSystemField.LINK,
      PurchaseOrderSourceSystemField.SOURCE_SYSTEM,
    ],
    filters: [{ member: PurchaseOrderSourceSystemField.INTERNAL_ID, operator: 'equals', values: [id] }],
  });

  const loading = dimPurchaseOrderQuery.isLoading || sourceSystemQuery.isLoading;

  const externalId =
    (dimPurchaseOrderQuery.resultSet?.rawData()?.[0]?.[DimPurchaseOrderField.PRIMARY_SOURCE_REFERENCE] as string) ?? '';

  const sourceSystemRows = sourceSystemQuery.resultSet?.rawData() ?? [];
  const links = sourceSystemRows.map((row) => ({
    title: `${row[PurchaseOrderSourceSystemField.SOURCE_REFERENCE] ?? ''}`,
    url: `${row[PurchaseOrderSourceSystemField.LINK] ?? ''}`,
  }));

  return (
    <BaseDetailHeader
      loading={loading}
      title={t('title', { id: externalId })}
      tabs={tabs}
      actionsRight={actionsRight}
      links={links}
    />
  );
};
